import { useState } from 'react'
import { TierBadge } from './TierBadge'

const DISMISS_KEY = 'ee_includedBannerDismissed'

/** "easyEnergy pays your subscription" banner, dismissible per session. */
export function BetaBanner() {
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === '1')
  if (dismissed) return null

  return (
    <div className="flex items-center justify-between gap-4 rounded-2xl bg-beige p-4">
      <p className="flex flex-wrap items-center gap-2 text-15 font-semibold text-dark-blue">
        <TierBadge tier="premium" className="!h-6 !px-2.5 !text-11" />
        Alle abonnementen worden betaald door easyEnergy — als klant gebruik je Premium gratis.
      </p>
      <button
        className="text-15 font-semibold text-dark-blue/40 transition-all duration-300 hover:text-dark-blue"
        aria-label="Sluiten"
        onClick={() => {
          sessionStorage.setItem(DISMISS_KEY, '1')
          setDismissed(true)
        }}
      >
        ✕
      </button>
    </div>
  )
}
